<ng-container *ngIf="currentForm_() as intakeForm">
	<div class="p-6">
		<div
			class="flex flex-col gap-4 p-8 border border-gray-200 rounded-2xl bg-white"
		>
			<div class="flex gap-6">
				<!-- TODO placeholder image used here until firm logo upload is implemented -->
				<img
					src="assets/images/closer-logo-green-c.png"
					alt="Law Firm Logo"
					class="h-12 w-auto object-contain"
				/>
				<h2 class="h2 self-start">{{ businessName_() }} Client Intake Form</h2>
			</div>

			<div class="flex gap-4">
				<h6 class="h6">Form Shared by</h6>
				<span class="text-sm font-normal">{{ loggedInUser_()?.name }}</span>
			</div>

			<p class="text-sm text-gray-700">
				Hi! Just a quick reminder to please complete the form at your earliest
				convenience. The details you provide help us move forward smoothly. Let
				us know if you have any questions—we're happy to assist. Thank you for
				your time and support!
			</p>
		</div>

		<div class="flex-1 min-w-0 mt-6" *ngIf="sortedForms_().length > 0">
			<core-tabs
				[initialTab]="selectedTab_()"
				(tabChange)="onTabChange($event)"
			>
				<ng-container *ngFor="let form of sortedForms_()">
					<core-tab [id]="form.id" [title]="form.name">
						<i-tabler
							*ngIf="form.clientId"
							pre-title
							[name]="form.clientId ? 'user' : 'file-text'"
							class="w-4 h-4"
						/>
					</core-tab>
				</ng-container>
			</core-tabs>
		</div>

		<div *ngIf="currentForm_()">
			<app-intake-form-renderer
				[intakeForm]="currentForm_()"
			></app-intake-form-renderer>
		</div>
	</div>
</ng-container>
